import { render } from "./PaymentFailed.vue?vue&type=template&id=0a48431f"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__